import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/energie";
export default function SecteurEnergie() { return <SectorLayout data={data} />; }
